import React from 'react'
import LayoutWithOutAccountCard from '../../layout/Layout/layout-without-card'

import ContactUsContent from '../../components/contact-us/contact-us'

function ContactUs() {
  return (
    <LayoutWithOutAccountCard breadCumKey='CONTACT_US' showEmptySpace={true} keyPath='Contact_Us'>
      <div className='new-design-form-style'>
        <ContactUsContent />
      </div>
    </LayoutWithOutAccountCard>
  )
}

export default ContactUs
